export default __webpack_public_path__ + "fcb0385241b01a611f290880f3bc13e0.gif";